import React, { Component } from 'react';
import { createPortal } from 'react-dom';
import { observer } from 'mobx-react';
import { Transition } from 'react-spring';

import ModalState from 'js/stores/ModalState';

import Dialog from './Dialog';
import Overlay from './Overlay';
import CloseModal from './CloseModal';

const body = document.getElementsByTagName('body')[0];

@observer
export default class Modal extends Component {
  startedInOverlay = false;
  modal = ModalState.create().setOnCancel(this.props.onCancel);

  overlayTag = Math.random()
    .toString(36)
    .slice(2);

  componentDidUpdate() {
    this.modal.displayUpdate(this.props.showModal);
  }

  isOverlayEvent(event) {
    return event.target.classList.contains(this.overlayTag);
  }

  onMouseDown = event => (this.startedInOverlay = this.isOverlayEvent(event));

  onCancel = event => {
    if (this.isOverlayEvent(event) && this.startedInOverlay) {
      this.immediateCancel();
    }
    this.startedInOverlay = false;
  };

  immediateCancel = () => {
    this.modal.onCancel();
    this.startedInOverlay = false;
  };

  render() {
    const { showModal, width, padded, withCloseButton, children } = this.props;
    return createPortal(
      <Transition
        native
        items={showModal}
        from={{ opacity: 0, transform: 'scale(0.9)' }}
        enter={{ opacity: 1, transform: 'scale(1)' }}
        leave={{ opacity: 0, transform: 'scale(0.9)' }}
        config={{ tension: 250, clamp: true }}>
        {showModal =>
          showModal &&
          (animation => (
            <Overlay
              style={{ opacity: animation.opacity }}
              tag={this.overlayTag}
              onMouseDown={this.onMouseDown}
              onClick={this.onCancel}>
              <Dialog
                modal={this.modal}
                style={animation}
                width={width}
                padded={padded}
                onClick={event => event.stopPropagation()}
                withCloseButton={withCloseButton}>
                {withCloseButton && <CloseModal onClick={this.immediateCancel} />}
                {children}
              </Dialog>
            </Overlay>
          ))
        }
      </Transition>,
      body,
    );
  }
}
